export default __webpack_public_path__ + "static/og-image-6b73c616f5489dd59a501d33da9a3947.jpg";